import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { listingSearchParam } from 'apis/handler/listing/listingSchema';

import type { MapPointsParam } from '../model/dto';
import { getListing, getListingMapPreview, getMapPoints } from './service';

export const getListingQueryKey = (searchParam: listingSearchParam) => {
  return ['listing', searchParam];
};

export const useGetListing = ({
  searchParam,
  enabled = true,
}: {
  searchParam: listingSearchParam;
  enabled?: boolean;
}) => {
  return useInfiniteQuery({
    queryKey: getListingQueryKey(searchParam),
    queryFn: ({ pageParam }) => getListing(searchParam, { page: pageParam, size: 10 }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => (lastPage.sliceInfo.hasNext ? lastPage.sliceInfo.pageNumber + 1 : undefined),
    placeholderData: keepPreviousData,
    // 대학 랜딩의 미등록 슬러그처럼 파라미터가 무효일 때 낭비 요청을 막는 스위치 (기본 true — 기존 호출부 무영향)
    enabled,
  });
};

export const useGetListingMapPreview = (id: number | null) => {
  return useQuery({
    queryKey: ['listing', 'map-preview', id],
    queryFn: () => getListingMapPreview(id!),
    enabled: id !== null,
  });
};

export const useGetMapPoints = ({ params }: { params: MapPointsParam | null }) => {
  return useQuery({
    queryKey: ['listing', 'map-points', params],
    queryFn: () => getMapPoints(params!),
    enabled: params !== null,
    placeholderData: keepPreviousData,
  });
};
